<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="管理员名称" prop="name" style="width: 50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="account" style="width: 50%">
        <el-input v-model="ruleForm.account" :disabled="ruleForm.uuid ? 'disabled' : false"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" style="width: 50%">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" style="width: 50%" :required="!ruleForm.uuid">
        <el-input v-model="ruleForm.password"></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="group_id">
        <el-select v-model="ruleForm.group_id" placeholder="请选择">
          <el-option v-for="(value, name) in groupList" :key="name" :label="value.title" :value="value.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getAdminAuthGroupSelect, saveAdmin, getAdminDetail, editAdmin } from "@/api/auth";
import { getGroupList } from "@/api/stage";

export default {
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    const validPassword = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      const reg = /^[A-Za-z0-9]{6,16}$/;
      if (!reg.test(value)) {
        callback(new Error("密码为6-16位数字或字母"));
      } else {
        callback();
      }
    };
    const validAccount = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/;
      if (!reg.test(value)) {
        callback(new Error("账号支持数字、英文"));
      } else {
        callback();
      }
    };
    return {
      form: {
        name: "",
        mobile: "",
        account: "",
        password: "",
        password1: "",
        group_id: "",
      },
      ruleForm: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入管理员名称",
            trigger: "blur",
          },
        ],
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validAccount, trigger: "blur" },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: phoneRules, trigger: "blur" },
        ],
        password: [{ validator: validPassword, trigger: "blur" }],
        group_id: [
          {
            required: true,
            message: "请选择角色权限",
            trigger: "change",
          },
        ],
      },
      groupList: [],
      stageList: [],
      dialogStageVisible: false,
      selectedStage: [],
      black: "",
      checkTagList: {},
      checkGroupList: {},
      dialogRelationVisible: false,
      userList: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      currentList: [],
    };
  },
  watch: {},
  async mounted() {
    const list = await getAdminAuthGroupSelect();
    this.groupList = list;
    if (this.$route.query.uuid) {
      this.ruleForm = this.$route.query;
      // const { uuid } = this.$route.query;
      // const res = await getAdminDetail(uuid);
      // if (res) {
      //     this.ruleForm = { ...res, account: res.mobile }
      // }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.uuid) {
            this.subEdit(this.$route.query.uuid);
          } else {
            this.subAdd();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async subEdit() {
      const res = await editAdmin(this.$route.query.uuid, this.ruleForm);
      if (res) {
        this.$notify({ title: "操作成功", type: "success" });
        this.$router.push({ path: "/admin-list" });
      }
    },
    async subAdd() {
      let res = (res = await saveAdmin(this.ruleForm));
      if (res) {
        this.$notify({ title: "操作成功", type: "success" });
        this.$router.push({ path: "/admin-list" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.w500 {
  width: 500px;
}
.stage {
  border: 1px dashed #999;
  border-radius: 5px;
  width: 800px;
  padding: 10px;
  margin-top: 8px;
  position: relative;
  .delete {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.stage-title {
  font-size: 23px;
  font-weight: 400;
  margin-top: 5px;
}
.stage-group,
.stage-tag {
  margin-top: 5px;
  font-size: 18px;
}
.empty {
  margin-left: 200px;
}
</style>
